import { useEffect } from "react";
import "./App.css";
import AppRoutes from "./AppRoutes";
import { useDispatch, useSelector } from "react-redux";
import { loginAction } from "./store/authSlice";
import { useNavigate } from "react-router-dom";
import { LOCAL_STORAGE_USER_KEY } from "./config";

function App() {
  const { isAuth } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const USER_DATA = localStorage.getItem(LOCAL_STORAGE_USER_KEY);
    const parserData = JSON.parse(USER_DATA);
    if (parserData?.jwt) {
      dispatch(loginAction({ data: parserData }));
    }
    if (isAuth) {
      navigate("/home");
    }
    // eslint-disable-next-line
  }, [isAuth]);

  return <AppRoutes isAuth={isAuth} />;
}

export default App;
